module.exports = __webpack_public_path__ + "img/20221217_FTX_report.1053f1b0.png";